import template from './template.html';
import './style.scss';

export class CandidateProfileCallForActionLabel {}

export const CandidateProfileCallForActionLabelConfiguration = {
    template,
    bindings: {
        callForAction: '<',
    },
    controller: CandidateProfileCallForActionLabel,
    controllerAs: 'candidateProfileCallForActionLabelCtrl',
};